import React from 'react';

const interviewSiteUrl = window.location.href;

export function Home() {
    return (
        <div>
            <p>In order to read exercise instructions, please click on the links below.</p>
            <p>Please put your work within each respective exercise React component (<strong>ClientApp\src\components\exercises</strong>) and corresponding C# Api Controller endpoint (<strong>Controllers\TestApiController.cs</strong>).</p>
            <p>You are welcome to make any other code changes as you see fit.</p>

            <ul>
                <li><a href="/banners">Exercise 1: Banners</a></li>
                <li><a href="/sports">Exercise 2: Sports</a></li>
                <li><a href="/validation">Exercise 3: Validation</a></li>
            </ul>

            <h2>Frequently Asked Questions</h2>

            <p><strong>How can I connect directly to the database server via SQL Server Enterprise Manager or SQL Server Management Studio?</strong></p>
            <p>The answer is that you can't connect directly to it from your own computer. We don't expose our test database server to the Internet because of security concerns.</p>

            You can work with the database in one of two ways:

            <ol>
                <li>We've prepared a set of SQL commands that you can run locally on your computer to build the table structures and fill the data. You'll just need to create a new blank database called "webapp" and then run the commands found in <strong>Controllers\HelperSql.sql.</strong></li>
                <li>The other option is for you to write your code and then upload it to our server via the FTP login and check your work in the browser (<a href={interviewSiteUrl}>{interviewSiteUrl}</a>). Before you hand in your test, you'll need to make sure it works on our server like this as we can't check the results on your computer - we can only check them on our server.</li>
            </ol>

            <p>A connection string has been included in <strong>appsettings.json</strong>. This is the connection string that should be included with your code when you submit it back to us. Change this to whatever you need to work locally, but don't forget to revert it so that we can check your work.</p>

            <p><strong>How do I prepare my submission?</strong></p>
            <p>When you are done, you must publish your solution before submitting everything via FTP. A publish profile has been included for your convenience.</p>
            <ol>
                <li>In Visual Studio, go to Build &gt; Publish InterviewTest <br /> <img alt="Publish Menu Screenshot" src="/images/publish-1.png" /></li>
                <li>Click Publish <br /> <img alt="Publish Button Screenshot" src="/images/publish-2.png" /></li>
                <li>The entire solution will compile at this point (.NET and JS), and everything will be placed in the publish folder.</li>
                <li>Once this is complete, you can go ahead and reupload all of your files to our FTP.<br /> <strong>IMPORTANT:</strong> To speed up the process PLEASE do not include <strong>node_modules</strong> when uploading via FTP.</li>
            </ol>

            <p><strong>How can I check my work?</strong></p>
            <p>You should check your work by going to the: <a href={interviewSiteUrl} target="_blank">{interviewSiteUrl}</a> site and making sure that the pages are working correctly. That is how we are going to be testing your work - by first going to the interview URL and pulling up the pages, then looking at your code after that.</p>
        </div>
    );
}
